import { SET_IPS_CONTENT } from './ipsActions';

export const defaultState = {
    isDataFetched: false,
    practice: [],
    questions: [],
};

const reformatItemContent = (apiItem) => ({
    ...(apiItem.item_id && { itemId: apiItem.item_id }),
    ...(apiItem.correct_response && { correctResponse: apiItem.correct_response.id }),
    stimulus: {
        audio: apiItem.stimulus.stimulus_audio,
        image: apiItem.stimulus.stimulus_image,
        phoneme: apiItem.stimulus.stimulus_phoneme.phoneme_audio,
    },
    possibleResponses: apiItem.possible_responses.map((possibleResponse) => ({
        id: possibleResponse.response_id,
        audio: possibleResponse.response_audio,
        image: possibleResponse.response_image,
    })),
});

/**
* Reformat content retrieved from API (snake_case)
* to the content format we need in front end (camelCase)
* @param {Object} apiContent
* @returns {Object}
*/
const reformatIPSContent = (apiContent) => ({
    formId: apiContent.form_id,
    measure: apiContent.measure,
    questions: apiContent.questions.map(reformatItemContent),
    practice: apiContent.practice.map(reformatItemContent),
});

const ipsReducer = (state = defaultState, action) => {
    switch (action.type) {
    case SET_IPS_CONTENT:
        return {
            ...state,
            isDataFetched: true,
            ...reformatIPSContent(action.content),
        };
    default:
        return state;
    }
};

export default ipsReducer;
